import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import NoticeShare from "../components/NoticeShare";
import { firebaseReady } from "../firebase";
import { subscribeToNotice } from "../noticeService";
import "./NoticePage.css";

export default function NoticeDetailPage() {
  const { noticeId } = useParams();
  const [notice, setNotice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [retryKey, setRetryKey] = useState(0);

  useEffect(() => {
    setLoading(true);
    setError("");
    if (!firebaseReady) {
      setError("Firebase कन्फिगरेसन पूरा भएको छैन।");
      setLoading(false);
      return undefined;
    }

    try {
      return subscribeToNotice(
        noticeId,
        (nextNotice, metadata) => {
          setNotice(nextNotice);
          setLoading(false);
          setError(
            metadata && metadata.fromCache
              ? "Firestore सर्भरसँग जडान हुन सकेन। इन्टरनेट जाँच गरी पुनः प्रयास गर्नुहोस्।"
              : "",
          );
        },
        (listenerError) => {
          setError(
            listenerError.code === "permission-denied"
              ? "यो सूचना हेर्ने अनुमति छैन।"
              : "सूचना लोड हुन सकेन। इन्टरनेट जाँच गरी पुनः प्रयास गर्नुहोस्।",
          );
          setLoading(false);
        },
      );
    } catch {
      setError("सूचना लोड हुन सकेन।");
      setLoading(false);
      return undefined;
    }
  }, [noticeId, retryKey]);

  return (
    <section className="notice-page">
      <div className="notice-page-header">
        <h1>सूचना तथा विज्ञप्ति</h1>
        <p>
          नेपाली कांग्रेस कुश्मी-गाउँ काठमाडौं सम्पर्क समितिका आधिकारिक सूचनाहरू
        </p>
      </div>
      <div className="notice-container">
        <Link className="notice-back-link" to="/notice">
          सूचीमा फर्कनुहोस्
        </Link>
        {loading && (
          <p className="notice-state" role="status">
            सूचनाहरू लोड हुँदैछन्…
          </p>
        )}
        {error && (
          <div className="notice-error" role="alert">
            <p>{error}</p>
            <button
              type="button"
              className="btn-cancel"
              onClick={() => setRetryKey((key) => key + 1)}
            >
              पुनः प्रयास गर्नुहोस्
            </button>
          </div>
        )}
        {!loading && !error && !notice && (
          <p className="notice-state">यो सूचना उपलब्ध छैन वा मेटिएको छ।</p>
        )}
        {!loading && !error && notice && (
          <article
            className={`notice-detail card ${notice.important ? "notice-important" : ""}`}
          >
            <div className="notice-meta">
              <span
                className={`notice-type-badge ${notice.type === "आह्वान" ? "type-call" : "type-info"}`}
              >
                {notice.type}
              </span>
              {notice.important && (
                <span className="important-badge">महत्त्वपूर्ण</span>
              )}
              <span className="notice-date">
                {notice.date || "मिति उपलब्ध छैन"}
              </span>
            </div>
            <h2 className="notice-title">
              {notice.title || "शीर्षक उपलब्ध छैन"}
            </h2>
            <p className="notice-detail-content">
              {notice.content || "विवरण उपलब्ध छैन।"}
            </p>
            <NoticeShare notice={notice} />
          </article>
        )}
      </div>
    </section>
  );
}
